export const kmSelectionPageOpen = {
    event: "Km selection Page Open",
    eventCategory: "km_selection_page",
    eventAction: "kmSelectionPageOpen"
};
export const  kmSelectionEdit = {
    event: "Edit Car Details on Km selection page",
    eventCategory: "km_selection_page",
    eventAction: "editCarDetails"
};
export const  kmSelectionClick = {
    event: "KM click on km selection page",
    eventCategory: "km_selection_page",
    eventAction: "",
    eventLabel: "kmSelection"
};
export const kmSelectionPhoneForm = {
    event: "Phone Number KM Selection Page",
    eventCategory: "km_selection_page",
    eventAction: "phoneForm",
    eventLabel: "NA"
};
export const kmSelectiongetCarPrice = {
    event: "Get Car Price click on KM selection page",
    eventCategory: "km_selection_page",
    eventAction: "getCarPrice"
};
